import { NavLink } from 'react-router-dom'
import { useAuthStore } from '../../stores/auth.store'
import { cn } from '../../lib/utils'

type NavItem = { label: string; path: string; icon: string }

const PRIMARY_ITEMS: Record<string, NavItem[]> = {
  HEAD_TEACHER: [
    { label: 'Home',     path: '/dashboard',   icon: '🏠' },
    { label: 'Schedule', path: '/schedule',    icon: '📅' },
    { label: 'Lessons',  path: '/lessons',     icon: '📝' },
    { label: 'Children', path: '/children',    icon: '👦' },
    { label: 'More',     path: '/settings',    icon: '⚙️' },
  ],
  PRINCIPAL: [
    { label: 'Home',     path: '/dashboard',   icon: '🏠' },
    { label: 'Schedule', path: '/schedule',    icon: '📅' },
    { label: 'Reports',  path: '/reports',     icon: '📄' },
    { label: 'Merits',   path: '/merits',      icon: '⭐' },
    { label: 'AI',       path: '/ai',          icon: '🤖' },
  ],
  TUTOR: [
    { label: 'Home',     path: '/dashboard',   icon: '🏠' },
    { label: 'Schedule', path: '/schedule',    icon: '📅' },
    { label: 'Lessons',  path: '/lessons',     icon: '📝' },
    { label: 'Homework', path: '/homework',    icon: '✏️' },
    { label: 'More',     path: '/settings',    icon: '⚙️' },
  ],
  STUDENT: [
    { label: 'Home',     path: '/dashboard',   icon: '🏠' },
    { label: 'Schedule', path: '/schedule',    icon: '📅' },
    { label: 'Homework', path: '/homework',    icon: '✏️' },
    { label: 'Merits',   path: '/merits',      icon: '⭐' },
  ],
}

export default function MobileNav() {
  const user  = useAuthStore((s) => s.user)
  const items = PRIMARY_ITEMS[user?.role ?? 'STUDENT'] ?? []

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 safe-area-inset-bottom">
      <div className="flex items-stretch">
        {items.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn(
                'flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-xs font-medium transition-colors',
                isActive
                  ? 'text-[#1B6B3A]'
                  : 'text-gray-500 hover:text-gray-700',
              )
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={cn(
                    'w-10 h-8 flex items-center justify-center rounded-xl text-base transition-colors',
                    isActive ? 'bg-[#1B6B3A]/10' : '',
                  )}
                >
                  {item.icon}
                </span>
                <span className="leading-tight">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
